module.exports = __webpack_public_path__ + "static/img/jp6.70f3a031.png";